import { render, staticRenderFns } from "./SalesAccounting.vue?vue&type=template&id=52f19656&"
import script from "./SalesAccounting.vue?vue&type=script&lang=js&"
export * from "./SalesAccounting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports